/** @format */
import localStorage from "local-storage";
import PersonIcon from "@mui/icons-material/Person";
import { Button, Grid, Tooltip, Typography } from "@mui/material";
import { lighten } from "polished";
const ledgerTypeMap = {
  SAHIS_BILANCO: "Şahıs Bilanço",
  ISLETME: "İşletme",
  TUZEL: "Tüzel",
  SERBEST_MESLEK: "Serbest Meslek",
  BASIT_USUL: "Basit Üsul",
};
const createColumnDefs = (navigate) => {
  return [
    {
      field: "id",
      headerName: "",
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,

      // enableCellTextSelection: true,
      // headerCheckboxSelection: true,
      // checkboxSelection: true,
      filter: false,
      cellRenderer: (params) => (
        <Button
          variant="contained"
          size="small"
          onClick={(event) => {
            if (event.ctrlKey || event.metaKey) {
              // CTRL (Windows) veya Command (Mac) tuşuna basılıyken yeni sekmede aç
              window.open(`/mukellef/waiting/${params.data.id}`, "_blank");
            } else {
              // Normal tıklamada yönlendir
              navigate(`/mukellef/waiting/${params.data.id}`);
            }
            localStorage.set("scrollPosition", Math.floor(window.scrollY));
          }}
          onMouseDown={(event) => {
            if (event.button === 1) {
              // Orta tıklama ile yeni sekmede aç
              event.preventDefault();
              window.open(`/mukellef/waiting/${params.data.id}`, "_blank");
            }
          }}
          sx={{ textTransform: "none", whiteSpace: "nowrap" }}
          startIcon={<PersonIcon />}
        >
          Mükellefi gör
        </Button>
      ),
    },
    {
      field: "vkn",
      headerName: "VKN",
      width: "10%",
      minWidth: 100,
      filter: "agTextColumnFilter", // Doğru kullanım

      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
      cellRenderer: (params) => (
        <Tooltip
          title={
            params.data?.vkn?.length === 10
              ? ""
              : "Vergi Kimlik No formatı yanlış lütfen düzeltin"
          }
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "700",
              color: params.data?.vkn?.length === 10 ? "" : "red",
              backgroundColor:
                params.data?.vkn?.length === 10 ? "" : lighten(0.4, "red"),
            }}
          >
            {params.data.vkn}{" "}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "tckn",
      headerName: "TCKN",
      width: "10%",
      minWidth: 110,
      filter: "agTextColumnFilter", // Doğru kullanım
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
      cellRenderer: (params) => (
        <Tooltip
          title={
            params.data?.tckn?.length === 11
              ? ""
              : "Tc Kimlik No formatı yanlış lütfen düzeltin"
          }
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "700",
              color: params.data.tckn?.length === 11 ? "" : "red",
              backgroundColor:
                params.data.tckn?.length === 11 ? "" : lighten(0.4, "red"),
            }}
          >
            {params.data.tckn}{" "}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "title",
      filter: "agTextColumnFilter", // Doğru kullanım

      headerName: "Ünvan",
      minWidth: 170,
      flex: 1,
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
    },
    {
      field: "declarations",
      headerName: "Onay Bekleyen Vergiler",
      maxWidth: 400,
      minWidth: 80,
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
    },
    {
      field: "number",
      filter: "agTextColumnFilter", // Doğru kullanım
      headerName: "Telefon ",
      width: "10%",
      minWidth: 120,
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
      cellRenderer: (params) => (
        <Grid
          item
          sx={{
            flexDirection: "row",
            display: "flex",
            overflow: "hidden",
            gap: 0.3,
          }}
        >
          {params.data.number.map((item, index) => (
            <Tooltip
              key={index}
              title={
                item.startsWith("5")
                  ? ""
                  : "Telefon numarası formatı yanlış lütfen düzeltin"
              }
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  color: item.startsWith("5") ? "" : "red",
                  backgroundColor: item.startsWith("5")
                    ? ""
                    : lighten(0.4, "red"),
                }}
              >
                {item} {index === params.data.number.length - 1 ? "" : ","}
              </Typography>
            </Tooltip>
          ))}
        </Grid>
      ),
    },
    {
      field: "mail",
      headerName: "E-posta Adresi",
      width: "15%",
      filter: "agTextColumnFilter", // Doğru kullanım

      minWidth: 180,
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
    },

    {
      field: "adress",
      headerName: "Adres",
      filter: "agTextColumnFilter", // Doğru kullanım
      hide: true,
      width: "20%", // Yüzdelik olarak genişlik belirlenebilir
      minWidth: 220, // Minimum genişlik belirlenebilir
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
        flexGrow: 1, // Hücrenin genişlemesini sağlar
      },
      suppressMenu: true,
    },
    {
      width: "10%",
      maxWidth: 120,
      field: "customerCard.ledgerType",
      headerName: "Defter Tipi",
      suppressMenu: true,
      valueGetter: (params) => {
        const value = params.data?.customerCard?.ledgerType;
        return value || null; // boşsa null dön
      },
      valueFormatter: (params) => {
        return ledgerTypeMap[params.value] || ""; // boşsa boş string döner
      },
      filter: "agSetColumnFilter",
      filterParams: {
        values: (params) => {
          // Grid'deki tüm verilerden benzersiz ledgerType değerlerini topla
          const rowData = params.api
            .getModel()
            .rowsToDisplay.map((row) => row.data);
          const uniqueValues = [
            ...new Set(
              rowData
                .map((data) => data?.customerCard?.ledgerType)
                .filter((value) => value !== undefined && value !== null) // null/undefined hariç tut
            ),
          ];
          params.success(uniqueValues); // Filtreye sadece mevcut değerleri gönder
        },
        valueFormatter: (params) => ledgerTypeMap[params.value] || "",
      },
    },
    {
      headerName: "Durum",
      field: "is_deleted",
      flex: 0,
      cellRenderer: (params) => {
        // Gelen veriye göre renk ve metin belirle
        let buttonText = "";
        if (params.data.is_deleted === false) {
          buttonText = "Aktif";
        } else {
          buttonText = "Pasif";
        }

        // Buton oluştur
        return (
          <button
            sx={{
              textTransform: "none",
              mb: "3%",
            }}
            style={{
              backgroundColor:
                buttonText === "Aktif"
                  ? lighten(0.4, "#5cb85c")
                  : lighten(0.3, "#f0ad4e"),
              color: buttonText === "Aktif" ? "#12450f" : "#b3545c",
              padding: "6px 12px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              width: "130px", // Tüm butonların genişliği (örneğin 200 piksel)
              "&:hover": {
                backgroundColor: "#1565c0", // Hover rengi
              },
            }}
          >
            {buttonText}
          </button>
        );
      },

      filterParams: {
        valueFormatter: function (params) {
          if (params.value === false) {
            return "Aktif";
          } else if (params.value === true) {
            return "Pasif";
          }
        },
      },
    },
  ];
};
export default createColumnDefs;
